import { RouterView } from "vue-router";

export const CalcRouting = {
  path: "/calc",
  name: "calc",
  component: RouterView,
  redirect: "/calc/index",
  meta: { title: "弱电计算器", icon: "calc" },
  children: [
    {
      path: "/calc/index",
      name: "calc-index",
      meta: { title: "弱电计算器" },
      component: () => import(/* webpackChunkName: "warehousing-list" */ "@/views/calc/index.vue"),
    },
  ],
};
